module.exports = __webpack_public_path__ + "img/wholesale5.3db6e8be.png";